const HOURLY_COUNT = 7;

function parseHourFromTime(timeText) {
  if (!timeText || typeof timeText !== 'string') {
    return null;
  }

  const match = timeText.match(/^(\d{1,2}):(\d{2})/);
  if (!match) {
    return null;
  }

  const hour = Number(match[1]);
  return Number.isFinite(hour) ? hour : null;
}

function getLocalDateKey(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function startOfCurrentHour(date = new Date()) {
  const hourStart = new Date(date);
  hourStart.setMinutes(0, 0, 0);
  return hourStart.getTime();
}

function entrySlotMs(entry, now = new Date()) {
  const hour = parseHourFromTime(entry?.time);
  if (hour == null) {
    return null;
  }

  const dateKey = entry?.date || getLocalDateKey(now);
  const slot = new Date(`${dateKey}T${String(hour).padStart(2, '0')}:00:00`);
  if (Number.isNaN(slot.getTime())) {
    return null;
  }

  return slot.getTime();
}

export function selectNextHourlyForecast(hourlyItems, count = HOURLY_COUNT, now = new Date()) {
  if (!Array.isArray(hourlyItems) || hourlyItems.length === 0) {
    return [];
  }

  const fromMs = startOfCurrentHour(now);

  return hourlyItems
    .map((entry) => ({ entry, slotMs: entrySlotMs(entry, now) }))
    .filter((item) => item.slotMs != null && item.slotMs >= fromMs)
    .sort((a, b) => a.slotMs - b.slotMs)
    .slice(0, count)
    .map((item) => item.entry);
}

export function findCurrentHourIrradiance(hourlyItems, now = new Date()) {
  if (!Array.isArray(hourlyItems) || hourlyItems.length === 0) {
    return null;
  }

  const today = getLocalDateKey(now);
  const currentHour = now.getHours();

  const match = hourlyItems.find((entry) => {
    const hour = parseHourFromTime(entry?.time);
    if (hour == null) {
      return false;
    }

    const entryDate = entry?.date || today;
    return entryDate === today && hour === currentHour;
  });

  const value = Number(match?.directNormalIrradiance);
  return Number.isFinite(value) ? Math.round(value) : null;
}
